import { render, staticRenderFns } from "./MainArticle.vue?vue&type=template&id=75857e11&scoped=true"
import script from "./MainArticle.vue?vue&type=script&lang=js"
export * from "./MainArticle.vue?vue&type=script&lang=js"
import style0 from "./MainArticle.vue?vue&type=style&index=0&id=75857e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75857e11",
  null
  
)

export default component.exports